<h1 mat-dialog-title>Sale Entry</h1>
<mat-dialog-content>
    <label for="sale-code">Sale Code</label>
    <input class="form-control" type="text" id="sale-code" [formControl]="entry">
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-button mat-flat-button color="primary" [disabled]="entry.invalid || loading" (click)="onSaleEntry()">
        Continue
    </button>
</mat-dialog-actions>
